<!--公司银行账户信息-->
<template>
  <div class="module">
    <h5 class="module-title">
      公司银行账户信息
      <span class="title-tips"
        >此账户作为向易派客在线支付账户转账激活使用，请确认该银行账户是否为贵司账户</span
      >
    </h5>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="开户行行号："
            prop="bankSerials"
            label-width="126px"
          >
            <span
              :style="{ 'margin-right': ruleForm.bankSerials ? '10px' : '' }"
              >{{ ruleForm.bankSerials }}</span
            >
            <el-button type="text" size="small" @click="addAndUpdateBankSerials"
              >{{ ruleForm.bankSerials ? '修改' : '添加行号' }}
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户银行：" prop="bankName" label-width="136px">
            <el-input
              v-model="ruleForm.bankName"
              placeholder="请输入开户银行"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="银行账户开户名："
            prop="bankAccountName"
            label-width="126px"
          >
            <el-input
              v-model="ruleForm.bankAccountName"
              placeholder="请输入银行账户开户名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="银行账户账号："
            prop="bankAccount"
            label-width="136px"
            required
          >
            <el-input
              v-model="ruleForm.bankAccount"
              placeholder="请输入银行账户账号"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 新增或修改行号-->
    <add-and-update-bank-series
      ref="addAndUpdateBankSeries"
      @confirm="confirmBankSeries"
    ></add-and-update-bank-series>
  </div>
</template>

<script>
import { paymentAccountOpeningMixins } from '../constant';
import AddAndUpdateBankSeries from './addAndUpdateBankSeriesDialog';

export default {
  name: 'BankAccountInfo',
  components: { AddAndUpdateBankSeries },
  mixins: [paymentAccountOpeningMixins],
  data() {
    return {
      loading: false,
      ruleForm: {
        bankAccount: '',
        bankAccountName: '',
        bankName: '',
        bankSerials: '',
      },
    };
  },
  watch: {},
  created() {},
  methods: {
    async initData(sourceData) {
      Object.keys(this.ruleForm).forEach((key) => {
        this.ruleForm[key] = sourceData[key];
      });
    },
    // 添加行号
    addAndUpdateBankSerials() {
      this.$refs.addAndUpdateBankSeries.initData();
    },
    confirmBankSeries(data) {
      this.ruleForm.bankName = data.bankName;
      this.ruleForm.bankSerials = data.bankNumber;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/paymentAccountOpening.scss';
</style>
